import React from 'react'
import { injectIntl } from "gatsby-plugin-intl"
// import ReactModal from 'react-modal'
import PropTypes from 'prop-types';
// import ContactFormWindow from './ContactFormWindow'

class Footer extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            // isModalOpen: false
        }
        // this.handleModalClose = this.handleModalClose.bind(this)
        // this.onContactFormClick = this.onContactFormClick.bind(this)
        // this.handleModalCloseByWindow = this.onContactFormClick.bind(this)
    }

    // onContactFormClick(e) {
    //     this.setState({ isModalOpen: true })
    //
    // }
    //
    // handleModalClose(e) {
    //     this.setState({ isModalOpen: false })
    // }
    //
    // handleModalCloseByWindow(data) {
    //     const { intl } = this.props
    //     if(data) {
    //         if(data.Success) {
    //             alert(intl.formatMessage({id: "util.ThanksForInquiry"}))
    //         } else {
    //             alert(intl.formatMessage({id: "util.SendError"}))
    //         }
    //     }
    //     this.setState({ isModalOpen: false })
    // }

    render() {
        const { intl } = this.props
        const company = "footer.company"
        const headOffice = "footer.headOffice"
        const address = "footer.address"
        const tel = "footer.tel"
        const CEO = "footer.CEO"
        const TAROTESHIMA = "footer.TAROTESHIMA"
        const privacy = "footer.privacy"
        const terms = "footer.terms"
        const notice = "footer.notice"
        const contact = "footer.contact"


        return (
            <footer>
            <div className="container">
                <h4>
                    { intl.formatMessage({id: company}) }
                </h4>
                <div className="office">
                <label>
                    { intl.formatMessage({id: headOffice}) }
                </label>
                    <div>
                    <p>
                        { intl.formatMessage({id: address}) }
                    </p>
                    <p>
                        { intl.formatMessage({id: tel}) }
                    </p>
                    </div>
                </div>
                <div className="office">
                <label>
                        { intl.formatMessage({id: CEO}) }
                </label>
                    <div>
                    <p>
                        { intl.formatMessage({id: TAROTESHIMA}) }
                    </p>
                    </div>
                </div>
            <div className="footer-text">
            <ul className="footer-link">
                <li>©Bank Invoice</li>
                <li>
                    <a href="/privacy.html" target="_blank"> { intl.formatMessage({id: privacy}) } </a>
                </li>
                <li>
                    <a href="/policy.html" target="_blank"> { intl.formatMessage({id: terms}) } </a>
                </li>
                <li>
                    <a href="/specified-commercial-transactions.html" target="_blank"> { intl.formatMessage({id: notice}) } </a>
                </li>
                <li>
                    <a href="https://app.paper.bankinvoice.com/inputforms/YLflEoawux/5IlnzdGlQU" target="_blank"> { intl.formatMessage({id: contact}) } </a>
                </li>
            </ul>
            </div>
            </div>
            </footer>
        )
    }
}

export default injectIntl(Footer)
